// Modules
import { createSelector } from '@ngrx/store';

// Store - Reducers
import { AppState } from '@store/reducers';
import * as ViewProfileReducer from '@store/reducers/view-profile.reducer';

export const selectViewProfileState = (state: AppState) => state.viewProfile;

export const selectUserProfile = createSelector(
  selectViewProfileState,
  (state: ViewProfileReducer.ViewProfileState) => state.user
);

export const selectViewProfileLoading = createSelector(
  selectViewProfileState,
  (state: ViewProfileReducer.ViewProfileState) => state.loadingViewProfile
);
